exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.date-question[data-v-62bb25fa] {\n    display: flex;\n    flex-direction: column;\n}\n.date-question input[data-v-62bb25fa] {\n    margin-top: 5px;\n}\n.date-question span[data-v-62bb25fa] {\n    color: red;\n    margin-top: 5px;\n}\n", ""]);

// exports
